import { useEffect, useState } from 'react';
import axios from 'axios';
import { OptionSet } from 'src/components/Tickets/models/Tickets.interface';

export const useGetTicketPriorities = () => {
  const [ticketPriorities, setTicketPriorities] = useState<OptionSet[]>();
  const [isLoadingTicketPriorities, setIsLoadingTicketPriorities] =
    useState<boolean>();
  const [ticketPrioritiesErrors, setTicketPrioritiesErrors] =
    useState<unknown>();

  const getTicketPriorities = async () => {
    setIsLoadingTicketPriorities(true);
    try {
      const response = await axios.get('api/option-sets/ticket-priorities');
      setTicketPriorities(response.data?.reverse());
    } catch (error) {
      console.error(error);
      setTicketPrioritiesErrors(error);
    } finally {
      setIsLoadingTicketPriorities(false);
    }
  };

  useEffect(() => {
    getTicketPriorities();
  }, []);

  return {
    ticketPriorities,
    isLoadingTicketPriorities,
    ticketPrioritiesErrors,
  };
};
